export const environment = {
  production: false,
  apiBaseUrl: 'https://testing-api.avs-digital.de',
  defaultGroupId: 3,
};
